import { render, staticRenderFns } from "./ActivityButton.vue?vue&type=template&id=56aaabfa&scoped=true"
import script from "./ActivityButton.vue?vue&type=script&lang=js"
export * from "./ActivityButton.vue?vue&type=script&lang=js"
import style0 from "./ActivityButton.vue?vue&type=style&index=0&id=56aaabfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56aaabfa",
  null
  
)

export default component.exports